import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { SpinnerGap, CheckCircle } from "@phosphor-icons/react";
import { api, errMsg } from "@/lib/api";
import { AuthShell, PwInput } from "./Login";

const btn = "flex h-12 w-full items-center justify-center gap-2 rounded-full bg-[#0E1729] font-semibold text-white disabled:opacity-60";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setErr("");
    try { await api.post("/auth/forgot-password", { email }); setSent(true); } catch (e2) { setErr(errMsg(e2)); } finally { setBusy(false); }
  };
  return (
    <AuthShell title="Forgot your password?" sub="Works for Google accounts too, if you want to add a password.">
      {sent ? (
        <div className="mt-6 rounded-2xl bg-[#E3EEE2] p-4 text-sm text-[#2C4E2A]" data-testid="forgot-sent"><CheckCircle size={20} weight="fill" className="mb-1" />If an account exists for <b>{email}</b>, we've emailed a link to choose a new password. It works for 1 hour.</div>
      ) : (
        <form onSubmit={submit} className="mt-6 space-y-4" data-testid="forgot-form">
          <label className="block text-sm font-medium text-[#0E1729]">Email<input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 h-12 w-full rounded-xl border-2 border-[#E3E8F0] px-4 text-base outline-none focus:border-[#0E1729]" data-testid="forgot-email-input" /></label>
          {err && <p className="rounded-xl bg-red-50 px-3 py-2 text-sm text-red-700" data-testid="forgot-error">{err}</p>}
          <button disabled={busy} className={btn} data-testid="forgot-submit-button">{busy ? <SpinnerGap className="animate-spin" /> : "Email me a link"}</button>
        </form>
      )}
      <p className="mt-6 text-center text-sm"><Link to="/login" className="font-semibold text-[#0E1729]" data-testid="forgot-back-login">Back to sign in</Link></p>
    </AuthShell>
  );
}

export function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setErr("");
    if (pw !== pw2) return setErr("The passwords don't match.");
    setBusy(true);
    try { await api.post("/auth/reset-password", { token: params.get("token") || "", password: pw }); setDone(true); setTimeout(() => nav("/login"), 2000); }
    catch (e2) { setErr(errMsg(e2)); } finally { setBusy(false); }
  };
  return (
    <AuthShell title="Choose a new password" sub="At least 8 characters.">
      {done ? <p className="mt-6 rounded-2xl bg-[#E3EEE2] p-4 text-sm text-[#2C4E2A]" data-testid="reset-done">Password saved. Taking you to sign in…</p> : (
        <form onSubmit={submit} className="mt-6 space-y-4" data-testid="reset-form">
          <div className="text-sm font-medium text-[#0E1729]">New password<PwInput value={pw} onChange={setPw} autoComplete="new-password" testId="reset-password-input" /></div>
          <div className="text-sm font-medium text-[#0E1729]">Repeat password<PwInput value={pw2} onChange={setPw2} autoComplete="new-password" testId="reset-password-confirm-input" /></div>
          {err && <p className="rounded-xl bg-red-50 px-3 py-2 text-sm text-red-700" data-testid="reset-error">{err}</p>}
          <button disabled={busy} className={btn} data-testid="reset-submit-button">{busy ? <SpinnerGap className="animate-spin" /> : "Save password"}</button>
        </form>
      )}
    </AuthShell>
  );
}
